import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Loader2 } from "lucide-react";

const PUNTI = [
  "Nessuna installazione, nessuna carta di credito",
  "Va bene per bar e tavola calda o fredda, pizzeria e ristorante",
  "Vedi anche il fondo cassa dello staff e la quadratura di fine giornata",
  "Dati di prova di un locale finto: prezzi e piatti sono solo esempi",
  "Guida passo-passo, si spegne quando vuoi",
];

/** Ingresso della demo: si dice cosa si sta per fare e si entra con un tocco. */
export const DemoIngresso = ({ onGuidata, onLibera, pronto }) => (
  <div className="min-h-screen bg-slate-950 px-6 py-10 text-slate-100" data-testid="demo-ingresso-page">
    <div className="mx-auto flex max-w-md flex-col">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500 font-head text-lg font-bold text-slate-950">
          RH
        </span>
        <div>
          <p className="font-head text-sm font-bold leading-none">Reprehendo</p>
          <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.24em] text-amber-500">Demo guidata</p>
        </div>
      </div>

      <div className="mt-10">
        <h1 className="font-head text-2xl font-bold leading-tight sm:text-3xl">
          Il gestionale per bar, pizzerie e ristoranti, spiegato in pochi passaggi
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Apri un tavolo o il banco, prendi l'ordinazione, mandala al reparto giusto e chiudi il
          conto: gli stessi gesti di una giornata vera, su un locale di prova. Ti accompagno io, un
          passo per volta.
        </p>

        <ul className="mt-6 space-y-2.5">
          {PUNTI.map((x, n) => (
            <li key={x} className="flex gap-2.5 text-sm text-slate-300" data-testid={`demo-ingresso-bullet-${n}`}>
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" /> {x}
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-10 space-y-3">
        <Button className="h-14 w-full text-base" onClick={onGuidata} disabled={!pronto}
                data-testid="demo-ingresso-start-btn">
          {pronto ? <>Iniziamo <ArrowRight className="ml-2 h-4 w-4" /></>
                  : <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Apro il locale di prova…</>}
        </Button>
        <button onClick={onLibera} disabled={!pronto}
                className="w-full py-3 text-sm font-semibold text-slate-400 disabled:opacity-40"
                data-testid="demo-ingresso-skip-btn">
          Guardo da solo, senza guida
        </button>
        <p className="pt-2 text-center text-[11px] text-slate-500">
          Demo in versione beta · nessun dato reale in questa pagina
        </p>
      </div>
    </div>
  </div>
);
